import { useNavigate } from "react-router-dom";
import { PartnersLogos } from "../components/PartnersLogos";
import { meetingData } from "../configs";
import { MainPartnerLogo } from "../components/MainPartnerLogo";

const Homepage = () => {
  const navigate = useNavigate()
  
  return (
    <div className="lg:container mx-auto flex flex-col min-h-screen">
      <div className="flex relative">
        <img
          src="/images/Hlucin-foto.jpg"
          alt="Hlučín a okolí"
          className="h-[60%] w-full"
        />
        <img
          src="/images/curve.svg"
          alt="Křivka"
          className="absolute bottom-0 left-0 w-full"
        />
        <div className="absolute bottom-1/2 left-4 xs:left-6 xl:left-8">
          <img
            src="/images/Hlucin-puchyr-logo.png"
            alt="Hlučín puchýř"
            className="w-18 2xs:w-20 xs:w-28 sm:w-36 md:w-44 lg:w-52 xl:w-56 2xl:w-60"
          />
        </div>
      </div>
      <div className="w-full flex flex-col md:flex-row justify-around items-center p-4 md:p-0">
        <div className="text-red-500 text-center mb-4">
          <h2 className="text-xl md:text-2xl font-semibold pt-4">
            {meetingData.year}
          </h2>
          <h1 className="text-4xl md:text-5xl font-bold my-4">
            {meetingData.title}
          </h1>
          <div className="flex justify-self-center p-4">
            <img
              src="/images/dots.svg"
              alt="Tečky"
              className="h-6 md:h-8"
            />
          </div>
          <h2 className="text-xl md:text-2xl font-semibold py-4 mb-4">
            {meetingData.date}
            <br />
            {meetingData.city}
            <br />
            {meetingData.region}
            <br />
            {meetingData.district}  
          </h2>
          <button
            className="bg-primary-default font-medium text-lg text-black hover:bg-primary-dark hover:text-white p-3 rounded"
            onClick={() => navigate("/latest-news")}
          >
            {meetingData.actualInfo}
          </button>
        </div>
      </div>
      <div className="flex-grow flex-col px-4">
        <h3 className="text-xl md:text-2xl font-semibold mb-4">
          {meetingData.initialMeetingTitle}
        </h3>
        {meetingData.initialMeetingDetail.map((detail: string, index: number) => (
          <p key={index} className="my-4 indent-6 text-justify">
            {detail}
          </p>
        ))}
      </div>
      <div className="mt-auto flex flex-col px-4">
        <h3 className="text-xl md:text-2xl font-semibold mb-4">
          {meetingData.mainMeetingPartner}
        </h3>
        <div className="flex flex-col items-center justify-center">
          <MainPartnerLogo />
          <p className="my-4 text-center">{meetingData.patronate}</p>
        </div>
        <h3 className="text-xl md:text-2xl font-semibold mb-4">
          {meetingData.meetingPartners}
        </h3>
        <PartnersLogos />
      </div>
    </div>
  );
}
  
export default Homepage;